import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import CardHeader from "../../components/common/CardHeader";
import { Card, Col, Row } from "react-bootstrap";
import LinkButton from "../../components/common/LinkButton";
import { ItemShow } from "../../components/form";
import toast from "react-hot-toast";
import { privateApi } from "../../api";

const UserShow = () => {
      const { userId } = useParams();
      const [user, setUser] = useState([]);

      const loadData = async () => {
            await privateApi
                  .get(`/dashboard/users/${userId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setUser(response.data.user);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="user Detail">
                                          <LinkButton
                                                link="/dashboard/users"
                                                title="Back"
                                          />
                                    </CardHeader>
                                    <Card.Body>
                                          <Row>
                                                {user?.image && (
                                                      <Col lg={4}>
                                                            <Card>
                                                                  <Card.Body className="text-center">
                                                                        <img
                                                                              className="w-100"
                                                                              src={`${user.image}`}
                                                                        />
                                                                  </Card.Body>
                                                            </Card>
                                                      </Col>
                                                )}
                                                <Col lg="8">
                                                      <ListGroup>
                                                            <ItemShow
                                                                  title="Full Name"
                                                                  value={
                                                                        user.name
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Email: "
                                                                  value={
                                                                        user.email
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Phone: "
                                                                  value={
                                                                        user.phone_number
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Role: "
                                                                  value={
                                                                        user.role
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Date "
                                                                  value={
                                                                        user.date
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Status"
                                                                  value={
                                                                        user.status ? (
                                                                              <>
                                                                                    <span className="text-success">
                                                                                          Active
                                                                                    </span>
                                                                              </>
                                                                        ) : (
                                                                              <>
                                                                                    <span className="text-warning">
                                                                                          Disable
                                                                                    </span>
                                                                              </>
                                                                        )
                                                                  }
                                                            />
                                                      </ListGroup>
                                                </Col>
                                          </Row>
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default UserShow;
